"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ = require("../..");
var _jsxRuntime = require("react/jsx-runtime");
var padding = _tokens.default.sky.sys.spacing['100'];
var backgroundColor = _tokens.default.sky.comp.shortcut.background.default;
var radius = _tokens.default.sky.sys.size.borderradius['1'];
var ShortcutSignifierContainer = _styledComponents.default.div.withConfig({
  displayName: "ShortcutSignifier__ShortcutSignifierContainer",
  componentId: "sc-1fprvam-0"
})(["display:inline-flex;border-radius:", ";background-color:", ";"], radius, backgroundColor);
var ShortcutSignifierText = _styledComponents.default.div.withConfig({
  displayName: "ShortcutSignifier__ShortcutSignifierText",
  componentId: "sc-1fprvam-1"
})(["display:flex;justify-content:center;align-items:center;padding:2px ", " 2px ", ""], padding, padding);
var ShortcutSignifier = function ShortcutSignifier(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ShortcutSignifierContainer, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ShortcutSignifierText, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Detail, {
        size: '1',
        children: name
      })
    })
  });
};
var _default = exports.default = ShortcutSignifier;